<template>
  <a-modal
    ref="refProPopup"
    title='选择商品'
    :visible='visible'
    @cancel='handleCancel'
    width="800px"
    :footer="null"
  >
    <a-form>
      <search-header :col="2">
        <search-list>
          <a-form-item label="商品名称" v-bind="formItemLayout">
            <a-input v-model="queryParams.proName" placeholder="请输入"></a-input>
          </a-form-item>
          <a-form-item label="商品ID" v-bind="formItemLayout">
            <a-input v-model="queryParams.proId" placeholder="请输入"></a-input>
          </a-form-item>
        </search-list>
        <search-list>
          <a-form-item label="商品分类" v-bind="formItemLayout">
            <a-select
              style="width: 100%"
              v-model="queryParams.proCatalog"
              placeholder="请选择" allowClear
            >
              <a-select-option v-for="item in proCatalogList" :key="item.code" :value="item.code">{{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item v-bind="formItemLayout" style="margin-left:3%;">
            <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
          </a-form-item>
        </search-list>
      </search-header>
      <a-form-item>
        <a-radio-group :defaultValue="queryParams.orderByKey" @change="onOrderChange">
          <a-radio-button :value="1">默认排序</a-radio-button>
          <a-radio-button :value="2">商品销量
            <span style="padding:6px;" @click="onClickProSale">
                <a-icon v-if="hanldSales" type="arrow-up"/>
                <a-icon v-else type="arrow-down"/>
              </span>

          </a-radio-button>
          <a-radio-button :value="3">发布时间
            <span style="padding:6px;" @click="onClickProDate">
                <a-icon v-if="hanldDate" type="arrow-up"/>
                <a-icon v-else type="arrow-down"/>
              </span>
          </a-radio-button>
        </a-radio-group>
      </a-form-item>
    </a-form>
    <custom-page-table
      ref="table"
      rowKey="proId"
      :columns="columns"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <div slot="action" slot-scope="data">
        <a @click="selectPro(data.record)">选择</a>
      </div>
    </custom-page-table>
  </a-modal>
</template>

<script>

export default {
  name: 'productPopupView',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      queryParams: {
        orderByKey: 1,
        proCatalog: undefined,
        proId: '',
        proName: '',
        orderByLead: 1
      },
      proCatalogList: [],
      loadPromise: params => this.getProListPromise(params),
      columns: [
        {
          title: 'ID',
          dataIndex: 'proId'
        },
        {
          title: '商品标题',
          dataIndex: 'proName'
        },
        {
          title: '当前推荐',
          width: '100px',
          dataIndex: 'recommendCount'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      hanldSales: true,
      hanldDate: true,
      dialogVisible: false
    }
  },
  watch: {
    'visible': function(newVal, oldVal) {
      this.dialogVisible = newVal
    }
  },
  mounted() {
    this.getProCatalogList()
    this.dialogVisible = false
  },
  methods: {
    handleCancel(e) {
      // this.getLogUtils().logWithTag('Clicked cancel button', this.$parent)
      // this.$parent.visiblePopup = false
      this.$emit('cancel')
    },
    getProListPromise(params) {
      this.getLogUtils().logWithTag('==getModularListPromise==', params)
      return this.getHttpServices().getUserService().post('homepage/recommend/get/modularProduct', params)
    },
    selectPro(item) {
      this.handleCancel()
      this.$emit('change', item)
    },
    onOrderChange(e) {
      this.getLogUtils().logWithTag('onOrderChange', e.target.value)
      this.queryParams.orderByKey = e.target.value
      this.$refs.table.refresh(true)
    },
    onClickProSale() {
      this.hanldSales = !this.hanldSales
      this.getLogUtils().logWithTag('onClickProSale', this.hanldSales)
      this.queryParams.orderByLead = this.hanldSales == true ? 1 : 2
      this.$refs.table.refresh(true)
    },
    onClickProDate() {
      this.hanldDate = !this.hanldDate
      this.queryParams.orderByLead = this.hanldDate == true ? 1 : 2
      this.$refs.table.refresh(true)
    },
    getProCatalogList() {
      this.getHttpServices().getApiService().post('homeMerchant/getMerchantNewField/' + this.$store.getters.userInfo.merchantId)
        .then(res => {
          if (res.productCatalogList && res.productCatalogList.length) {
            let allProCategoryList = this.getAppConstants().getProductTypeList()
            res.productCatalogList.forEach(item => {
              allProCategoryList.forEach(v => {
                if (item === v.code) this.proCatalogList.push(v)
              })
            })
          }
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }

}
</script>
<style scoped>
</style>